import { useTranslation } from 'react-i18next'

import { useTimeZone } from '../../../../../../hooks'
import { useCloseConfirm } from '../../../../../Form'
import { FormikForm } from '../../../../../Formik'
import { WidgetFormContainer } from '../../../../../Widget'
import { useApplicantProfileContext } from '../../../RentalPortalApplicantProfile.hooks'
import { useApplicantBlockSave } from '../../RentalPortalApplicantProfileTabOverview.hooks'
import { APPLICANT_MATCHING_DISCARD_CONFIRMATION_PROPS } from '../ApplicantMatchingWidget.constants'
import {
  getApplicantMatchingInitialValues,
  getApplicantMatchingPatchPayload,
  getApplicantMatchingValidationSchema,
} from '../ApplicantMatchingWidget.utils'

import { ApplicantMatchingWidgetFormFields } from './ApplicantMatchingWidgetFormFields'

function ApplicantMatchingWidgetForm({ onClose, onSuccess }) {
  const { t } = useTranslation()

  const timezone = useTimeZone()

  const { applicantData } = useApplicantProfileContext()

  const {
    handleAddNotification,
    handleRemoveNotification,
    handleSaveBlock,
    notifications,
  } = useApplicantBlockSave({ onClose, onSuccess })

  const { handleClose, isCloseConfirm, setCloseConfirm } = useCloseConfirm({
    onClose,
  })

  function handleSubmit(values, formikHelpers) {
    handleSaveBlock({
      formikHelpers,
      payload: getApplicantMatchingPatchPayload(values),
    })
  }

  return (
    <FormikForm
      Container={WidgetFormContainer}
      containerProps={{
        confirmationProps: APPLICANT_MATCHING_DISCARD_CONFIRMATION_PROPS,
        isCloseConfirm,
        setCloseConfirm,
        onClose,
      }}
      initialValues={getApplicantMatchingInitialValues({
        applicantData,
        t,
        timezone,
      })}
      validateOnBlur={false}
      validateOnChange={false}
      validationSchema={getApplicantMatchingValidationSchema()}
      onSubmit={handleSubmit}
    >
      <ApplicantMatchingWidgetFormFields
        isCloseConfirm={isCloseConfirm}
        notifications={notifications}
        onCancel={handleClose}
        onRemoveNotification={handleRemoveNotification}
        onSetNotification={handleAddNotification}
      />
    </FormikForm>
  )
}

export default ApplicantMatchingWidgetForm
